import React from 'react';
import { Hero } from './components/Hero';
import { Section } from './components/Section';
import { AboutLiza } from './components/AboutLiza';
import { DaysTimeline } from './components/DaysTimeline';
import { ForYou } from './components/ForYou';
import { Gift } from './components/Gift';
import { DownloadCTA } from './components/DownloadCTA';
import { Closing } from './components/Closing';
export function App() {
  return <main className="grain min-h-full w-full" data-id="element-0" data-mp="2rlozuqfd2dda">
      <Hero data-id="element-1" data-mp="2rikrdguv4vgt" />

      <Section eyebrow="La herida que nadie está nombrando" title="El 24 de junio la tierra tembló." className="bg-[#faf4ec]" data-id="element-2" data-mp="2mm2nskb9r362">
        <div className="space-y-4 text-base leading-relaxed text-[#5c4d44]" data-id="element-3" data-mp="31c1jmgfcq2id">
          <p data-id="element-4" data-mp="2wj8ehrfz0s5r">Y con ella, también tembló algo dentro de nosotros.</p>
          <p data-id="element-5" data-mp="28tw5arkn8k3g">
            Quizás todavía sientes ese nudo en el pecho cuando escuchas un ruido
            fuerte. Quizás duermes diferente. O no puedes dormir. Quizás sigues
            revisando el teléfono esperando otra alerta. Quizás sonríes afuera,
            pero por dentro todavía tiemblas.
          </p>
          <p className="font-serif text-lg italic text-[#8f5238]" data-id="element-6" data-mp="3mkrgru1fnxhj">
            Eso tiene nombre: es duelo colectivo. Y es completamente normal.
          </p>
        </div>
      </Section>

      <AboutLiza data-id="element-7" data-mp="6hpnd64cbd2" />
      <DaysTimeline data-id="element-8" data-mp="4ww9qvjiygs" />
      <ForYou data-id="element-9" data-mp="56nfhsbnbo2" />
      <Gift data-id="element-10" data-mp="82j0zgp5o9c" />
      <DownloadCTA data-id="element-11" data-mp="2zl3alhpbj03q" />
      <Closing data-id="element-12" data-mp="2zlldgx6hkckm" />
    </main>;
}